import React from 'react'
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core'
import Typography from '@material-ui/core/Typography'
import format from 'date-fns/format'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  period: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '-60px',
    left: '16px'
  },
  label: {
    marginRight: 4,
    fontSize: 11,
    color: '#8688A1'
  },
  value: {
    color: '#860BCA'
  }
}

const PeriodBase = ({ classes, selectedWave }) => {
  return (
    <Plugin name='Export'>
      <Template name='top'>
        <TemplatePlaceholder />
        <div className={classes.period}>
          <Typography className={classes.label} variant='h6'>
            PERIOD:
          </Typography>
          <Typography className={classes.value} variant='h5'>{`${format(selectedWave.startDate, 'MMMM dd, yyyy')} - Today`}</Typography>
        </div>
      </Template>
    </Plugin>
  )
}

export default withStyles(styles)(PeriodBase)
